import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from './connection.service';
import { Observable } from 'rxjs';

export interface KioskState {
  panel: string;
  newCustomer?: {
    name?: string;
    phone?: string;
    email?: string;
  };
  existingSearch?: string;
  console?: {
    type?: string | null;
    issue?: string;
  };
  laptop?: {
    modelNumber?: string;
    issue?: string;
  };
  dataRecovery?: {
    type?: string | null;
    files?: string;
  };
  other?: {
    issue?: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class KioskStateService {
  private readonly baseUrl = this.connection.address + '/kiosk-service';

  constructor(private http: HttpClient, private connection: ConnectionService) {}

  getState(): Observable<KioskState> {
    return this.http.get<KioskState>(`${this.baseUrl}/state`);
  }

  saveState(state: KioskState): Observable<KioskState> {
    return this.http.post<KioskState>(`${this.baseUrl}/state`, state);
  }
}
